import { PatternNoteTypes } from '@/utils/constants'
import type { GalleryPatternDraft } from './buildGalleryPatternDraft'

type AddNoteFn = (params: {
  topicID: string
  noteName: string
  noteText: string
  noteType: string
  egoItems: []
}) => Promise<unknown>

/**
 * Persist a PatternDraft as topic notes — same contract as pattern editor
 * `copyDraftToTopic` (guest → auth save). Editor loads these via initializePatternData
 * then RestorePattern → applySurfaceProperties.
 */
export async function persistPatternNotes(
  topicID: string,
  draft: GalleryPatternDraft,
  addNote: AddNoteFn,
): Promise<void> {
  for (const key of Object.keys(draft) as (keyof GalleryPatternDraft)[]) {
    const noteType = PatternNoteTypes[key as string]
    if (!noteType) continue
    const value = draft[key]
    await addNote({
      topicID,
      noteName: key as string,
      noteText: JSON.stringify(value ?? null),
      noteType,
      egoItems: [],
    })
  }
}
